import TopCounter from "./topCounter";
import TopSlider from "./topSlider";
import Specs from "./Specs";
import UpcomingSubscribers from "./upcomingSubscribers";
import PrizesGrid from "./prizesGrid";
import CompetitionTitle from "./competitionTitle";
import SubscribersOnly from "./subscribersOnly";
import CheckmarkIcon from "../../../../shared-components/icons/CheckmarkIcon";
import OtherCompButton from "./otherCompButton";
import CtaButton from "./ctaButton";
import SocialReviewBadges from "./socialReviewBadges";
import React from "react";
import { useSubscriptionCompetitionsPrizesPageContext } from "../context";
import MoreTickets from "@/app/(custom-header)/prizes/[prizeName]/components/moreTickets";

const DesktopLayout = () => {
  const { isAlreadySubscribed, activeCompetition, openTabContent, lobbyContent } =
    useSubscriptionCompetitionsPrizesPageContext();
  const youveEnteredEntry = lobbyContent.youveEntered.find(
    item => Number(item.compid) === activeCompetition.CompetitionId
  );
  return (
    <section className={"w-full"}>
      {activeCompetition.EndDateTime ? <TopCounter endDateTime={activeCompetition.EndDateTime} /> : null}
      <div className={"lg:px-6 mt-[35px] mb-14"}>
        <div className="w-full max-w-[1360px] mx-auto">
          <div className={"grid grid-cols-1 lg:grid-cols-[66.176%_1fr] gap-6 lg:gap-[4.265%]"}>
            <section className={"w-full"}>
              <TopSlider />

              <div className={"mt-10"}>
                <Specs />
              </div>

              <div className={"mt-10"}>
                <UpcomingSubscribers />
              </div>

              <div className={"mt-10"}>
                <PrizesGrid />
              </div>
            </section>
            <section className={"w-full"}>
              <div className={"sticky w-full top-[95px]"}>
                <div className="w-full">
                  <CompetitionTitle title={activeCompetition.CtaText} onClick={e => openTabContent(e, 1)} />
                </div>

                <div className={"mt-10 flex flex-col gap-3"}>
                  <SubscribersOnly isAlreadySubscribed={isAlreadySubscribed} />
                  {isAlreadySubscribed ? null : <MoreTickets />}
                </div>

                <div className={"mt-3 w-full flex flex-col gap-2"}>
                  {isAlreadySubscribed && youveEnteredEntry && (
                    <div className={"flex items-center gap-px lg:gap-1"}>
                      <CheckmarkIcon variation={4} className={"size-6 shrink-0 text-[#308835]"} />
                      <div className={"text-[#308835] text-center text-sm leading-4"}>
                        You entered in this competition with{" "}
                        <span className={"font-semibold"}>
                          {youveEnteredEntry.nrOfTickets} {youveEnteredEntry.nrOfTickets === 1 ? "ticket" : "tickets"}
                        </span>
                      </div>
                    </div>
                  )}
                  {isAlreadySubscribed ? <OtherCompButton /> : <CtaButton />}
                </div>

                <div className={"mt-8"}>
                  <SocialReviewBadges />
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DesktopLayout;
